import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@mmlogic/components/loader';
import { defineCustomElements as defineOrgchartElements } from '@rulebooks/rulebooks-orgchart/loader';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

defineCustomElements();
// mrd-graph-view (GRAPH layout items) hosts <rulebooks-orgchart> but doesn't bundle it:
// the package lives in the private Rulebooks registry, so the host registers it (TASK-0407).
defineOrgchartElements();

// ng-add copies pdf.js's "bleeding-edge" build (worker/cmaps/locale) into the
// build output at this path (see angular.json assets) — without pointing
// ngx-extended-pdf-viewer at it, the worker fails to load and PDFs render as a
// blank page while the viewer chrome still shows (TASK-0170).
pdfDefaultOptions.assetsFolder = 'bleeding-edge';

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
